import { render } from "./ChangePasswordSection.vue?vue&type=template&id=289a3184&scoped=true"
import script from "./ChangePasswordSection.vue?vue&type=script&lang=js"
export * from "./ChangePasswordSection.vue?vue&type=script&lang=js"

import "./ChangePasswordSection.vue?vue&type=style&index=0&id=289a3184&lang=scss&scoped=true"
/* custom blocks */
import block0 from "@/locales/ru/components/user-settings-view/change-password-section.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fuser-settings-view%2FChangePasswordSection.vue&locale=ru"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locales/en/components/user-settings-view/change-password-section.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fuser-settings-view%2FChangePasswordSection.vue&locale=en"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-289a3184"]])

export default __exports__